import LoadingBackdrop from '@/components/loadingBackdrop/LoadingBackdrop';
import { RichText } from '@/components/richText/RichText';
import type { ReplacementsType } from '@/helper/replacements';
import { useUserStore } from '@/providers/UserStoreProvider';
import type { RichtextStoryblok } from '@/types/component-types-sb';
import { useEffect, useState } from 'react';

import classes from './LoginBox.module.scss';

type LoginBoxProps = {
  replacements: ReplacementsType;
  loggedInText?: RichtextStoryblok;
  loggedOutText?: RichtextStoryblok;
};

const LoginBox: React.FC<LoginBoxProps> = ({ replacements, loggedInText, loggedOutText }) => {
  const { loggedIn, isRedirecting, loggingIn } = useUserStore((state) => ({
    loggedIn: state.loggedIn,
    isRedirecting: state.isRedirecting,
    loggingIn: state.loggingIn,
  }));
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!loggingIn && !isRedirecting) {
      setLoading(false);
    }
  }, [loggingIn, isRedirecting]);

  return (
    <>
      <LoadingBackdrop loading={loading} type="card" />
      {!loading && (
        <div className={classes.LoginContainer}>
          {loggedIn && <RichText text={loggedInText} replace={replacements} />}
          {!loggedIn && <RichText text={loggedOutText} replace={replacements} />}
        </div>
      )}
    </>
  );
};

export default LoginBox;
